import { useEffect } from 'react';
import realtimeNotification from 'srcJs/components/realtime-notification/realtime-notification';
import { MESSAGE_TYPE_DATA_LAYER } from 'srcJs/components/realtime-notification/constants/constants';
import { useGTMDispatch } from 'components/google-tag-manager/use-gtm-dispatch';
import app from 'srcJs/App';
import { useHistory } from 'react-router';
import { useNetworkService } from 'hooks/use-network-service';
import { APP_LOAD_DATA_LAYER_URL } from 'moduleBase/constants';

var DataLayerObserver = function DataLayerObserver() {
  if (!app.getExternalApp().isEnableGoogleTagManager()) {
    return null;
  }

  var gtmDispatch = useGTMDispatch();
  var history = useHistory();
  var networkService = useNetworkService();

  var sendData = function sendData(message) {
    gtmDispatch(message.data);
  };

  var handlerChangeUrl = function handlerChangeUrl() {
    networkService.get(APP_LOAD_DATA_LAYER_URL).then(function (response) {
      gtmDispatch(response.data.data); // eslint-disable-next-line @typescript-eslint/no-empty-function
    })["catch"](function () {});
  };

  useEffect(function () {
    realtimeNotification.addListener(MESSAGE_TYPE_DATA_LAYER, sendData);
    var historyUnregister = history.listen(handlerChangeUrl);
    return function () {
      realtimeNotification.removeListener(sendData);
      historyUnregister();
    };
  }, []);
  return null;
};

export { DataLayerObserver };